"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.mergeVariableConfigurations = function (variables, variableConfigurations) {
    if (variables === void 0) { variables = {}; }
    if (variableConfigurations === void 0) { variableConfigurations = []; }
    return tslib_1.__assign({}, getConfigurationValues(variableConfigurations), variables);
};
function getConfigurationValues(variableConfigurations) {
    return Object.assign.apply(Object, tslib_1.__spread([{}], variableConfigurations.map(function (_a) {
        var id = _a.id, default_value = _a.default_value;
        return (_b = {}, _b[id] = default_value, _b);
        var _b;
    })));
}
//# sourceMappingURL=merge-variable-configurations.js.map